import React from 'react';
import PropTypes from 'prop-types';

import { CheckIconSm, MinusIconSm } from '@chownow/pantry/icons';
export function CustomCheckboxIcon({ indeterminate, className }) {
  const IconComponent = indeterminate ? MinusIconSm : CheckIconSm;

  return <IconComponent className={className} style={{ width: '16px', height: '16px' }} />;
}

CustomCheckboxIcon.propTypes = {
  indeterminate: PropTypes.bool,
  className: PropTypes.string,
};
